import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { TaasRsData } from '@ps20/bff-models';
import { App } from '@ps20-frontend/frontend-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { RsActions } from '../rsActions';
import { IAppState } from '../appState';
import { buildTaasRSDataForStrecke } from './transformer/rsData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasRsData>;

export function* streckenTarifierungRS(): Generator<ForkEffect> {
  const requestActions = [
    TARIF_CHECKED,
    ZUSATZOPTION_CHECKED,
    ZUSATZOPTION_UNCHECKED,
    RsActions.PREISE_REQUESTED,
    RsActions.SELBSTBETEILIGUNG_CHANGED,
    RsActions.OPTIONALE_LEISTUNG_CHANGED,
    RsActions.ANZAHLFAHRZEUG_CHANGED,
    RsActions.FAHRZEUGART_CHANGED,
  ];
  const successActions = [
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_RS,
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_RS,
  ];

  streckenTarifierer = new StreckenTarifierer(
    {
      appId: App.RS,
      successEventWithInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_RS,
      successEventWithoutInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_RS,
      errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_RS,
    },
    buildTaasRSDataForStrecke,
    undefined,
    createHashedRelevantRiskdataRS,
  );

  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.RS));
  yield takeEvery(successActions, safeSaga(streckenTarifierer.handleSuccess, App.RS));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_RS,
    safeSaga(streckenTarifierer.handleError, App.RS),
  );
}

export function createHashedRelevantRiskdataRS(taasData: TaasRsData): string {
  const relevantData = { ...taasData };

  delete relevantData.salesProducts;
  delete relevantData.spartenType;
  delete relevantData.verkehrBaustein;
  delete relevantData.vermieterBausteine;

  return createHashedTaasData(relevantData);
}
